<template>
  <div class="reg-form-item" v-if="data">
    <FormItem :label="data.name">
      <!-- field-info text -->
      <p class="field-info" v-if="data.helpText">{{ data.helpText }}</p>

      <!-- input case -->
      <template v-if="getFieldTag(data.fieldType, 'input')">
        <Input :required="data.required" :type="getInputType(data.fieldType)" />
      </template>

      <!-- country case -->
      <template v-else-if="data.fieldType === 'country'">
        <Select filterable placeholder="Please select one">
          <Option
            v-for="country in countries"
            :value="country"
            :key="country"
            >{{ country }}</Option
          >
        </Select>
      </template>

      <!-- checkbox case -->
      <template v-else-if="getFieldTag(data.fieldType, 'checkbox')">
        <Checkbox>{{ data.name }}</Checkbox>
      </template>

      <!-- selectbox -->
      <template v-else-if="data.fieldType === 'selectbox'">
        <Select placeholder="Please select one">
          <Option
            v-for="option in selectBoxOptions"
            :value="option"
            :key="option"
            >{{ option }}</Option
          >
          <Option v-if="data.selectBoxUseOther" value="other">Other</Option>
        </Select>
      </template>

      <!-- HTML Content -->
      <template v-else-if="data.fieldYype === 'html_content'">
        <vue-editor v-model="data.html" />
      </template>

      <!-- remove button -->
      <Button
        class="remove-field"
        :class="{
          'remove-field--checkbox': getFieldTag(data.fieldType, 'checkbox'),
        }"
        @click="removeField(data._id)"
      >
        <Icon type="ios-trash" size="16" />
      </Button>
    </FormItem>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import countries from './countries.json'

export default {
  props: ['data'],
  data() {
    return {
      countries: countries.map(country => country.name),
      newFieldsMappings: {
        input: [
          'name',
          'name6',
          'last_name',
          'email',
          'event_password',
          'city',
          'phone',
          'short_text',
          'long_text',
          'number',
          'tcid',
          'birth_year',
          'tcidf'
        ],
        select: ['country'],
        checkbox: ['email_permission', 'checkbox']
      }
    }
  },
  computed: {
    selectBoxOptions() {
      return this.data.selectBoxOptions.split(',')
    }
  },
  methods: {
    ...mapActions('reg-form', {
      removeFieldFromStore: 'remove'
    }),

    removeField(id) {
      this.removeFieldFromStore(id).then(response => console.log(response))
    },

    getFieldTag(fieldType, htmlTag) {
      return this.newFieldsMappings[htmlTag].includes(fieldType)
    },

    getInputType(fieldType) {
      if (fieldType == 'email') return 'email'
      else if (fieldType == 'event_password') return 'password'
      else if (fieldType == 'long_text') return 'textarea'
      else return 'text'
    }
  }
}
</script>

<style lang="scss" scoped>
.form-info {
  margin: 25px 0;
}

.field-info {
  width: 100%;
  clear: both;
}

.remove-field {
  padding: 7px 24px;
  border-left-color: transparent;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  &--checkbox {
    border: none;
    background-color: transparent;
  }
  &:focus {
    box-shadow: none;
  }
}
</style>

<style lang="scss">
.reg-form-item {
  .ivu-form-item-content {
    display: flex;
    flex-wrap: wrap;
    clear: both;

    .ivu-input-wrapper,
    .ivu-select {
      width: auto;
      flex: 1;
    }
  }

  .ivu-select-input {
    height: 34px;
  }
}
</style>
